import React, { useEffect, useState } from 'react';
import '../style.scss';
import Footer from './footer';
import Header from '../../../app/layouts/Header';
import { useDispatch, useSelector } from 'react-redux';
import { loadLocalStore } from '../../../app/reducers/authorization-slice';
import type { RootState } from '../../../app/store';
import Message from '../../../components/message';
import { hideMessage } from '../../../app/reducers/message-slice';

/**
 * Auth shell:
 * header (fixed) → body (fills viewport + grows) → main (stretches) + footer
 */
const DashboardLayout = (props: { children?: React.ReactNode }) => {
  const [isLoaded, setLoaded] = useState(false);
  const message = useSelector((state: RootState) => state.message);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isLoaded) {
      dispatch(loadLocalStore());
      setLoaded(true);
    }
  }, [dispatch, isLoaded]);

  return (
    <div className="authorizated-layout">
      <Header />
      <div className="authorizated-layout__body">
        <main className="authorizated-layout__main container pt-3 pb-3">
          {props.children}
          {message.value ? (
            <Message callback={() => dispatch(hideMessage())} {...message} />
          ) : null}
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default DashboardLayout;
